import { createContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const VendorResolverContext = /*#__PURE__*/createContext({});
export const VendorResolverProvider = ({
  resolveVendor,
  children
}) => /*#__PURE__*/_jsx(VendorResolverContext.Provider, {
  value: {
    resolveVendor
  },
  children: children
});
VendorResolverProvider.displayName = 'VendorResolverProvider';